import { useEffect, useState } from "react";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import genericStyles from "../../Styles/genericStyles.module.css";
import ExamQuestionForm from "./ExamQuestionForm";
import { ExamQuestionModel } from "../../Utils/Models";
import { getData } from "../../Services/getData";
import GenericModal from "../GenericModal";
import { Button } from "@mui/material";
import { FormsIds } from "../../Utils/Constants";

export default function ExamQuestionsTable(props: { name: string }) {
  const [openModal, setOpenModal] = useState(false);
  const [contextValue, setContextValue] = useState<
    ExamQuestionModel | undefined
  >(undefined);
  const [triggerReload, setTriggerReload] = useState(false);
  const [examSets, setExamSets] = useState<
    { _id: string; name: string; examCategory: string }[]
  >([]);

  useEffect(() => {
    getData(endpoints.examSets).then((res) => {
      if (Array.isArray(res?.data)) setExamSets(res.data);
      else if (Array.isArray(res?.data?.results)) setExamSets(res.data.results);
    });
  }, []);

  const columns = [
    {
      name: "questionText",
      label: Vocabulary.question || "Întrebare",
      options: { filter: true, sort: true },
    },
    {
      name: "answers",
      label: Vocabulary.answers || "Răspunsuri",
      options: {
        customBodyRender: (value: any) =>
          Array.isArray(value)
            ? value.map((a: any) => a.text).join(", ")
            : value,
      },
    },
    // Add more columns as needed
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.MODAL}
        title={Vocabulary.examQuestions || "Întrebări Examen"}
        columns={columns}
        CRUDEndPoint={endpoints.examQuestions}
        handleModalForm={setOpenModal}
        setContextValue={setContextValue}
        triggerReload={triggerReload}
        addOrEditForm={
          <GenericModal
            title={contextValue?._id ? Vocabulary.edit : Vocabulary.add}
            open={openModal}
            onClose={() => {
              setOpenModal(false);
              setContextValue(undefined);
            }}
            actions={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setOpenModal(false);
                    setContextValue(undefined);
                  }}
                >
                  {Vocabulary.cancel}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  color="primary"
                  form={FormsIds.examQuestionForm}
                >
                  {Vocabulary.save}
                </Button>
              </div>
            }
          >
            <ExamQuestionForm
              onClose={() => {
                setOpenModal(false);
                setContextValue(undefined);
                setTriggerReload(!triggerReload);
              }}
              selectedRow={contextValue}
              examSets={examSets}
            />
          </GenericModal>
        }
      />
    </div>
  );
}
